import { render } from "./medium.vue?vue&type=template&id=dcbe4de4"
import script from "./medium.vue?vue&type=script&lang=js"
export * from "./medium.vue?vue&type=script&lang=js"

import "./medium.vue?vue&type=style&index=0&id=dcbe4de4&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__